module.exports = __webpack_public_path__ + "img/timekeeper_square.63499152.svg";